<template>
  <div id="opponent-lineup-containier" class="border-padding">
  <main>
    <h2>Lineup Stats vs Opponent Lineup</h2>
    <div class="row">
      <div class="col-md-4" v-if="season_dropdown.data != undefined">
        <season-select v-model="seasons_selected" :options="season_dropdown" :inputFunc="changePlayers"></season-select>
      </div>

      <div class="col-md-1" v-if="team_dropdown.data != undefined">
        <team-select v-model="team_selected" :options="team_dropdown" :inputFunc="changePlayers" :preselectFirst="true" :allowEmpty="false"></team-select>
      </div>

      <div class="col-md-2" v-if="season_type_dropdown.data != undefined">
        <season-type-select v-model="season_type_selected" :options="season_type_dropdown"></season-type-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6" v-if="players.length > 0">
        <label class="typo__label">Lineup (Enter exactly 5 players)</label>
        <multiselect
          v-model="players_selected"
          :options="players"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="true"
          :hide-selected="true"
          :preserve-search="true"
          placeholder=""
          label="name"
          track-by="playerId"
          :preselect-first="false">
          <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.name }}</span><span class="custom__remove" @click="props.remove(props.option)">❌</span></span></template>
        </multiselect>
      </div>
    </div>
    <div class="border-padding" v-if="players_selected.length == 5">
      <button class="" v-on:click="changeStats()">Get Opponent Lineups</button>
    </div>
    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div v-if="table_data.length > 0">
        <vue-good-table
            :columns="table_columns"
            :rows="table_data"
            :pagination-options="{ enabled: true, perPage: 30}"
            :searchOptions="{ enabled: false}"
            :sort-options="{ enabled: true, initialSortBy: {field: 'total_possessions', type: 'desc'}}"
            styleClass="vgt-table bordered striped">
            <template slot="table-row" slot-scope="props">
              <div>
                <span>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </div>
            </template>
            <template slot="table-column" slot-scope="props">
            <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
                {{props.column.label}}
            </span>
            <span v-else>
                {{props.column.label}}
            </span>
            </template>
        </vue-good-table>
    </div>
  </main>
  </div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import SeasonTypeSelect from './mixins/SeasonTypeSelect.vue'
import SeasonSelect from './mixins/SeasonSelect.vue'
import TeamSelect from './mixins/TeamSelect.vue'
import GetDropdownOptions from './mixins/get_dropdown'
import { season, seasonType } from './mixins/dropdowns'

export default {
  name: 'OpponentLineupSummary',
  components: {
    Multiselect,
    SeasonTypeSelect,
    SeasonSelect,
    TeamSelect
  },
  mixins: [SeasonTypeSelect, SeasonSelect, TeamSelect, GetDropdownOptions, season, seasonType],
  data () {
    return {
      loading: false,
      season: undefined,
      season_type: undefined,
      lineup_id: undefined,
      lineup_name: undefined,
      team_dropdown: {},
      season_dropdown: {},
      team_selected: undefined,
      seasons_selected: [],
      season_type_dropdown: {},
      season_type_selected: undefined,
      players: [],
      players_selected: [],
      season_selected_string: undefined,
      table_data: [],
      table_columns: [
        {'field': 'lineup', 'label': 'Opponent'},
        {'field': 'team', 'label': 'Team'},
        {'field': 'minutes', 'label': 'Minutes'},
        {'field': 'total_possessions', 'label': 'Poss', 'type': 'number', 'tooltip': 'Total Possessions'},
        {'field': 'pts_for', 'label': 'Pts', 'type': 'number'},
        {'field': 'pts_against', 'label': 'Pts Against', 'type': 'number'},
        {'field': 'plus_minus', 'label': 'P/M', 'type': 'number', 'tooltip': 'Plus Minus'},
        {'field': 'ortg', 'label': 'ORtg', 'type': 'decimal', 'tooltip': 'Points Per 100 Possessions'},
        {'field': 'drtg', 'label': 'DRtg', 'type': 'decimal', 'tooltip': 'Points Against Per 100 Possessions'},
        {'field': 'net_rtg', 'label': 'NetRtg', 'type': 'decimal'},
        {'field': 'fg2m', 'label': 'FG2M', 'type': 'number'},
        {'field': 'fg2a', 'label': 'FG2A', 'type': 'number'},
        {'field': 'fg2pct', 'label': 'FG2%', 'type': 'percentage'},
        {'field': 'fg3m', 'label': 'FG3M', 'type': 'number'},
        {'field': 'fg3a', 'label': 'FG3A', 'type': 'number'},
        {'field': 'fg3pct', 'label': 'FG3%', 'type': 'percentage'},
        {'field': 'efg', 'label': 'eFG%', 'type': 'percentage'},
        {'field': 'orebs', 'label': 'ORebs', 'type': 'number'},
        {'field': 'oreb_pct', 'label': 'OREB%', 'type': 'percentage'},
        {'field': 'turnovers', 'label': 'TOV', 'type': 'number'},
        {'field': 'tov_pct', 'label': 'TOV%', 'type': 'percentage'},
        {'field': 'opp_ftr', 'label': 'FTr', 'type': 'decimal', 'tooltip': 'Free Throw Rate'},
        {'field': 'opp_fg2m', 'label': 'Opp. FG2M', 'type': 'number'},
        {'field': 'opp_fg2a', 'label': 'Opp. FG2A', 'type': 'number'},
        {'field': 'opp_fg2pct', 'label': 'Opp. FG2%', 'type': 'percentage'},
        {'field': 'opp_fg3m', 'label': 'Opp. FG3M', 'type': 'number'},
        {'field': 'opp_fg3a', 'label': 'Opp. FG3A', 'type': 'number'},
        {'field': 'opp_fg3pct', 'label': 'Opp. FG3%', 'type': 'percentage'},
        {'field': 'opp_efg', 'label': 'Opp. eFG%', 'type': 'percentage'},
        {'field': 'drebs', 'label': 'DRebs', 'type': 'number'},
        {'field': 'dreb_pct', 'label': 'DREB%', 'type': 'percentage'},
        {'field': 'opp_turnovers', 'label': 'Opp. TOV', 'type': 'number'},
        {'field': 'opp_tov_pct', 'label': 'Opp. TOV%', 'type': 'percentage'},
        {'field': 'opp_ftr', 'label': 'Opp. FTr', 'type': 'decimal', 'tooltip': 'Opponent Free Throw Rate'}
      ],
      show_error_message: false,
      api_endpoint: 'get-lineup-opponent-summary/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData'
  },
  methods: {
    loadData () {
      this.getDropdown([this.setSeasonDropdown, this.setSeasonTypeDropdown, this.setTeamDropdown, this.getPlayers])
      if (this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.TeamId && this.$route.query.LineupId) {
        this.lineup_id = this.$route.query.LineupId
        this.getStats()
      }
    },
    updateData () {
      if (this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.TeamId && this.$route.query.LineupId) {
        this.getStats()
      }
    },
    changePlayers () {
      this.players_selected = []
      this.season_selected_string = this.getSeasonsSelectedString()
      if (this.season_dropdown.data.length > 0 && this.team_selected) {
        this.getPlayers()
      }
    },
    getPlayers (callbacks) {
      this.season_selected_string = this.getSeasonsSelectedString()

      var params = {}
      params[this.$teamIdParam] = this.team_selected.id
      params[this.$seasonParam] = this.season_selected_string
      params[this.$seasonTypeParam] = this.season_type_selected.id

      axios.get(process.env.API_BASE_URL + 'get-team-players-for-season', {
        params: params
      })
        .then((response) => {
          this.player_ids = Object.keys(response.data.players)
          this.players = []
          this.player_ids.forEach((playerId) => {
            this.players.push({'playerId': playerId, 'name': response.data.players[playerId]})
          })

          this.setPlayers(this.players)
        }, (error) => {
          this.error = error
        })
    },
    setPlayers (allPlayers) {
      if (this.lineup_id) {
        var playerIds = this.getPlayerIdsFromLineupId()
        allPlayers.forEach((player) => {
          if (playerIds.indexOf(player.playerId) > -1) {
            this.players_selected.push(player)
          }
        })
      }
    },
    generateLineupId () {
      if (this.players_selected.length === 5) {
        var playerIds = [this.players_selected[0].playerId, this.players_selected[1].playerId, this.players_selected[2].playerId, this.players_selected[3].playerId, this.players_selected[4].playerId]
        playerIds.sort()
        var lineupId = playerIds.join('-')
        return lineupId
      }
    },
    getPlayerIdsFromLineupId () {
      return this.lineup_id.split('-')
    },
    changeStats () {
      var params = {}
      this.lineup_id = this.generateLineupId()
      params[this.$lineupIdParam] = this.lineup_id
      params[this.$teamIdParam] = this.team_selected.id
      params[this.$seasonParam] = this.getSeasonsSelectedString()
      params[this.$seasonTypeParam] = this.season_type_selected.id
      this.$router.push({name: 'opponent_lineup_summary', query: params})
    },
    getStats () {
      this.show_error_message = false
      this.table_data = []

      if (this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.TeamId && this.$route.query.LineupId) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
          params: this.$route.query
        })
          .then((response) => {
            if (!response.data.error) {
              this.table_data = response.data.results
              this.lineup_name = response.data.lineup_name
            } else {
              this.show_error_message = true
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
          })
      }
    }
  }
}
</script>

<style scoped>
@import "https://maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"

</style>



// WEBPACK FOOTER //
// src/components/OpponentLineupSummary.vue